var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    ref: "liveroomContainer",
    staticClass: "liveroom",
    class: {
      minimum: _vm.minimum
    }
  }, [_c('div', {
    staticClass: "main-wrapper"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "player"
  }, [_c('videoplayer', {
    ref: "player",
    attrs: {
      "authentication": _vm.authentication,
      "isHandLiveroom": false,
      "showHearts": !_vm.minimum,
      "vid": _vm.channelID,
      "hostid": _vm.anchorID,
      "showLoading": true,
      "completed": _vm.completed,
      "deleted": _vm.deleted,
      "downloader": _vm.preloader,
      "src": _vm.mediaSource,
      "poster": _vm.mediaPoster,
      "options": _vm.mediaOptions
    },
    on: {
      "mediaevent": _vm.mediaEventHandler,
      "playerevent": _vm.playerEventHandler
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "boardcaster"
  }, [_vm._v(_vm._s(_vm.anchorName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('profile', {
    ref: "profile",
    attrs: {
      "authentication": _vm.authentication,
      "channelID": _vm.channelID,
      "anchorID": _vm.anchorID,
      "heatCount": _vm.heatCount
    },
    on: {
      "subscribe": _vm.subscribeHandler,
      "opencard": _vm.opencard
    }
  }), _vm._v(" "), _c('chatter', {
    ref: "chatter",
    attrs: {
      "playState": _vm.playState
    },
    on: {
      "subscribe": _vm.subscribeHandler,
      "opencard": _vm.openCardWithGlobalPosition
    }
  }), _vm._v(" "), _c('message-box', {
    on: {
      "submit": _vm.sendTextMessage
    }
  })], 1)]), _vm._v(" "), _vm.isShowGiftWall ? _c('div', {
    staticClass: "toolbar-wrapper"
  }, [_c('div', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.notification')))]), _vm._v(" "), _c('toolbar', {
    ref: "toolbar",
    attrs: {
      "authentication": _vm.authentication,
      "giftList": _vm.giftList,
      "giftTabs": _vm.giftTabs,
      "isOpenGiftWall": _vm.isOpenGiftWall
    },
    on: {
      "recharge": _vm.rechargeHandler,
      "authenticate": _vm.authenticateHandler,
      "sendgift": _vm.sendGiftMessage,
      "opengiftwall": _vm.openGiftWallHandler
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.showGiftWallTooltipVisible ? _c('tooltip', {
    staticClass: "for-giftwall",
    attrs: {
      "direction": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.tooltipGiftWall')))]) : _vm._e(), _vm._v(" "), _vm.showFollowTooltipVisible ? _c('tooltip', {
    staticClass: "for-profile",
    attrs: {
      "direction": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.tooltipFollowButton')))]) : _vm._e(), _vm._v(" "), _vm.showShareTooltipVisible ? _c('tooltip', {
    staticClass: "for-share",
    attrs: {
      "direction": "top"
    }
  }, [_vm._v(_vm._s(_vm.$t('webrtc.wrliveroom.shareBtn')))]) : _vm._e(), _vm._v(" "), _c('toast', {
    attrs: {
      "visible": _vm.toastVisible,
      "message": _vm.toastMessage
    },
    on: {
      "close": _vm.hideToastMessage
    }
  })], 1), _vm._v(" "), _c('top-gifters', {
    ref: "topGifters",
    attrs: {
      "hostid": _vm.anchorID,
      "videoid": _vm.channelID
    },
    on: {
      "authenticate": _vm.authenticateHandler,
      "opencard": _vm.opencard
    }
  }), _vm._v(" "), _vm.showFollowModalVisible ? _c('follow-modal', {
    attrs: {
      "anchorID": _vm.anchorID,
      "anchorPortrait": _vm.anchorPortrait
    },
    on: {
      "cancel": _vm.cancelFollowModal,
      "accept": _vm.acceptFollowModal
    }
  }) : _vm._e(), _vm._v(" "), _c('personalcard', {
    ref: "personalcard",
    attrs: {
      "isShowCard": _vm.isShowCard,
      "channelID": _vm.channelID,
      "anchorID": _vm.anchorID,
      "targetUid": _vm.cardTargetUid,
      "cardType": _vm.cardType,
      "top": _vm.cardTop,
      "left": _vm.cardLeft
    },
    on: {
      "closecard": _vm.closecard,
      "subscribeHandler": _vm.subscribeHandler
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };